import { Grid, GridItem, Typography } from '@fe-toolkit/web-components/ssr'
import { useTheme } from 'styled-components'

export const ContractsPriceFreezeBenefitsTable = () => {
  const theme = useTheme()

  return (
    <Grid
      gridColumns={2}
      sx={{
        border: `1px solid ${theme.colors.alto}`,
        borderRadius: theme.borderRadius.small,
        overflow: 'hidden',

        // double ampersand required to override Grid's default styling for 'gap'
        '&&': {
          gap: '0px',
        },

        [GridItem]: {
          borderBottom: `1px solid ${theme.colors.alto}`,
          padding: '12px',

          '&:nth-child(odd)': {
            borderRight: `1px solid ${theme.colors.alto}`,
          },

          '&:nth-last-child(-n + 2)': {
            borderBottom: `none`,
          },
        },
      }}
    >
      <GridItem backgroundColor={theme.colors.gallery}>
        <Typography variant="murmurBold">giffgaff 24 month fixed term</Typography>
      </GridItem>
      <GridItem backgroundColor={theme.colors.gallery}>
        <Typography variant="murmurBold">The other guys</Typography>
      </GridItem>

      <GridItem>
        <Typography variant="murmur">Fixed prices</Typography>
      </GridItem>
      <GridItem>
        <Typography variant="murmur">Prices go up</Typography>
      </GridItem>

      <GridItem>
        <Typography variant="murmur">April 2027. Fixed</Typography>
      </GridItem>
      <GridItem>
        <Typography variant="murmur">April 2027. Goes up</Typography>
      </GridItem>

      <GridItem>
        <Typography variant="murmur">April 2028. Still fixed</Typography>
      </GridItem>
      <GridItem>
        <Typography variant="murmur">April 2028. Up again</Typography>
      </GridItem>

      <GridItem>
        <Typography variant="murmur">Peace of mind</Typography>
      </GridItem>
      <GridItem>
        <Typography variant="murmur">An April surprise</Typography>
      </GridItem>
    </Grid>
  )
}
